import { create } from "zustand"

// Define the Project interface and export it for use in other files
export interface Project {
  id: string
  Owner: string
  Designlanguage: string
  Goal: string
  Languages: string[]
  Name: string
  Status: string
  Type: string
  Created_at: string
  Created_by: string
  // The project list folder ("." separated), from the project's metadata.
  Folder?: string
}

// Define the store state and actions interface
interface ProjectStore {
  project: Project

  // Actions
  setProject: (project: Project) => void
  updateProject: (updates: Partial<Project>) => void
  updateProjectField: <K extends keyof Project>(
    field: K,
    value: Project[K]
  ) => void
  resetProject: () => void

  // Getter helpers
  getProjectId: () => string
  getProjectName: () => string
}

/**
 * Zustand store to manage project state in the application.
 *
 * @returns Store with project state and actions
 */
export const useProjectStore = create<ProjectStore>((set, get) => ({
  project: {
    id: "",
    Owner: "",
    Designlanguage: "",
    Goal: "",
    Languages: [],
    Name: "",
    Status: "",
    Type: "",
    Created_at: "",
    Created_by: "",
  },

  // Actions
  setProject: (project: Project) => set({ project }),

  updateProject: (updates: Partial<Project>) =>
    set((state) => ({
      project: { ...state.project, ...updates },
    })),

  updateProjectField: <K extends keyof Project>(field: K, value: Project[K]) =>
    set((state) => ({
      project: { ...state.project, [field]: value },
    })),

  resetProject: () =>
    set({
      project: {
        id: "",
        Owner: "",
        Designlanguage: "",
        Goal: "",
        Languages: [],
        Name: "",
        Status: "",
        Type: "",
        Created_at: "",
        Created_by: "",
      },
    }),

  // Getter helpers (optional)
  getProjectId: () => get().project.id,
  getProjectName: () => get().project.Name,
}))
